import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { useUser } from '../../../../hooks/useUser'

export function usePedidos(filtros = {}) {
  const { codigo_usuario } = useUser()

  const buildQueryParams = (filtros) => {
    const params = new URLSearchParams()

    if (filtros.numeroPedido) params.append('codigo', filtros.numeroPedido)
    if (filtros.dataInicio) params.append('data_inicio', formatDateToAPI(filtros.dataInicio))
    if (filtros.dataFim) params.append('data_fim', formatDateToAPI(filtros.dataFim))
    if (filtros.passoAtual) params.append('status', filtros.passoAtual)
    if (filtros.proximoPasso) params.append('proximo_passo', filtros.proximoPasso)
    if (codigo_usuario) params.append('codigo_usuario', codigo_usuario)

    return params.toString()
  }

  const formatDateToAPI = (dateString) => {
    if (!dateString) return ''
    return dateString
  }

  const fetchPedidos = async () => {
    const queryString = buildQueryParams(filtros)
    const url = `/site/v2/tercerizado/listar-pedidos-tercerizado${queryString ? `?${queryString}` : ''}`

    const response = await api.get(url)

    return response.data.map((pedido) => ({
      dataEntrada: formatarDataHora(pedido.data_entrada),
      codigo: (pedido.codigo_produto || 0).toString(),
      produto: pedido.nome_produto,
      cor: pedido.cor_produto,
      gravacao: pedido.gravacao,
      quantidade:
        typeof pedido.quantidade === 'number' ? pedido.quantidade.toLocaleString('pt-BR') : Number(pedido.quantidade || 0).toLocaleString('pt-BR'),
      valorUnitario:
        typeof pedido.valor_unitario === 'number'
          ? `R$ ${pedido.valor_unitario.toFixed(2).replace('.', ',')}`
          : `R$ ${Number(pedido.valor_unitario || 0)
              .toFixed(2)
              .replace('.', ',')}`,
      subtotal:
        typeof pedido.sub_total === 'number'
          ? `R$ ${pedido.sub_total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',')}`
          : `R$ ${Number(pedido.sub_total || 0)
              .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              .replace('.', ',')}`,
      logo: pedido.link_logo,
      layout: pedido.link_pdf,
      observacao: pedido.observacao || '',
      prazoProducao: `${pedido.prazo_producao} dias úteis`,
      status: pedido.status,
    }))
  }

  return useQuery(['@pedidos-em-analise', filtros], fetchPedidos, {
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 2,
    keepPreviousData: true,
  })
}

function formatarDataHora(dataString) {
  if (!dataString) return ''

  try {
    const [dataParte, horaParte] = dataString.split(' ')
    if (!dataParte) return dataString

    const [ano, mes, dia] = dataParte.split('-')
    const hora = horaParte ? horaParte.split('.')[0] : ''

    return `${dia}/${mes}/${ano} ${hora}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return dataString
  }
}

export function adicionarPedidoAoCache(queryClient, novoPedido) {
  const queryKeys = queryClient.getQueryCache().findAll(['@pedidos-em-analise'])

  queryKeys.forEach((query) => {
    queryClient.setQueryData(query.queryKey, (pedidosAntigos = []) => {
      const pedidoFormatado = {
        dataEntrada: formatarDataHora(novoPedido.data_entrada) || formatarDataHora(new Date().toISOString()),
        codigo: (novoPedido.codigo_produto || 0).toString(),
        produto: novoPedido.nome_produto,
        cor: novoPedido.cor_produto,
        gravacao: novoPedido.gravacao,
        quantidade:
          typeof novoPedido.quantidade === 'number'
            ? novoPedido.quantidade.toLocaleString('pt-BR')
            : Number(novoPedido.quantidade || 0).toLocaleString('pt-BR'),
        valorUnitario: `R$ ${Number(novoPedido.valor_unitario || 0)
          .toFixed(2)
          .replace('.', ',')}`,
        subtotal: `R$ ${Number(novoPedido.sub_total || 0)
          .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          .replace('.', ',')}`,
        logo: novoPedido.link_logo,
        layout: novoPedido.link_pdf,
        observacao: novoPedido.observacao || '',
        prazoProducao: `${novoPedido.prazo_producao} dias úteis`,
        status: novoPedido.status || 'Aguardando Aprovação',
      }

      const pedidoExistente = pedidosAntigos.findIndex((p) => p.codigo === pedidoFormatado.codigo && p.produto === pedidoFormatado.produto)

      if (pedidoExistente >= 0) {
        const novosPedidos = [...pedidosAntigos]
        novosPedidos[pedidoExistente] = pedidoFormatado
        return novosPedidos
      } else {
        return [pedidoFormatado, ...pedidosAntigos]
      }
    })
  })
}
